import 'core-js/stable'
window.axios = require('axios');
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import vuexI18n from 'vuex-i18n';
import Locales from './locale/vue-i18n-locales.generated.js';
window.moment = require('moment');
window.$ = window.jQuery = require('jquery')

import 'vue-select/dist/vue-select.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import SmallLoader from './views/components/small_loader'
Vue.component('small-loader', SmallLoader)

import Spacer from './views/components/spacer'
Vue.component('spacer', Spacer)

axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.log('main axios err')
  console.log(error.response.status)
  if (error.response.status === 401) {
    console.log(router)
    setTimeout(function () {
      if (router.currentRoute.path.substr(0, 14) !== '/register_user') {
        console.log('going to login')
        router.push('/login')
      }
    }, 500)
  } else if (error.response.status === 422) {
    if (router.currentRoute.path.substr(0, 14) !== '/register_user') {
      router.push('/login')
    }
  }
});
// import Swal from 'sweetalert2'
// window.Swal = Swal
Vue.prototype.$apiAdress = 'https://server.paireports.live'
// Vue.prototype.$apiAdress = 'http://127.0.0.1:8000'
Vue.use(CoreuiVue)
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('en', Locales.en);
Vue.i18n.add('pl', Locales.pl);
let locale = 'en'
if(typeof localStorage.locale !== 'undefined'){
  locale = localStorage.getItem("locale")
}
Vue.i18n.set(locale);

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  components: {
    App
  }
})

